import { SimpleRouterNavigationExtras } from '@platform-frontend/util';
import { GotoCheckoutFlowAction } from '../flow/flow.actions';
import { RefreshCheckoutMessageParams } from '../flow/model/checkout-sanitized-start-params';

export class FetchAssets {
  static readonly type = '[Asset] Fetch assets';
}

export class CancelSubscription {
  static readonly type = '[Asset] Cancel subscription';
}

export class ConfirmSubscriptionPriceUpdate {
  static readonly type = '[Asset] Confirm subscription price update';
}

export class ConfirmSubscriptionEulaUpdate {
  static readonly type = '[Asset] Confirm subscription eula update';
}

export class GotoSubscriptionManagement extends GotoCheckoutFlowAction {
  static readonly type = '[Asset] Goto subscription management';
  constructor(public startParams: RefreshCheckoutMessageParams, public extras?: SimpleRouterNavigationExtras) {
    super(startParams, extras);
  }
}

export class GotoPurchaseInformation extends GotoCheckoutFlowAction {
  static readonly type = '[Asset] Goto purchase information';
  constructor(public startParams: RefreshCheckoutMessageParams, public extras?: SimpleRouterNavigationExtras) {
    super(startParams, extras);
  }
}
